import type { Enums } from "@msuite/utils/types";
import { boolean, json, number, string, table } from "@rocicorp/zero";

export const plan = table("plans")
	.columns({
		id: string(),
		date: string(),
		orgId: string().from("org_id"),
		state: string<Enums<"planState">>(),
		publishedAt: number().from("published_at").optional(),
		publishedBy: string().from("published_by").optional(),
		skippedTickets: json<string[]>().from("skipped_tickets"),
		notificationsEnabled: boolean().from("notifications_enabled"),
	})
	.primaryKey("id");
